import React from 'react'
import {useLocation} from 'react-router-dom'

const SessionAiBanner = () => {
    const location = useLocation()
    const pathname = location?.pathname || ''
    const shouldHide = /\/checkout(?:\/|$)/.test(pathname)

    if (shouldHide) return null
    return <div id="z1-rto-popup" className="z1-rto-client-container" />
}

export default SessionAiBanner
